<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="cached" v-model="form.status" :options="status_select">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint'],
    
        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                status_select: data.status_select,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' },
                    status: { source:'status', default:'draft' },
                },
                titles: {
                    new: lang.polaris.training.new_list,
                    duplicate: lang.polaris.training.list_duplicate,
                    update: lang.polaris.training.list_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });

            this.bus.$on(that.id+'-data-duplicate', function(data) {
                that.form = data;
                that.form.name += ' (' + lang.polaris.training.copy + ')';
                that.form.status = 'draft';
            });
        }

    }
</script>
